// extracted by mini-css-extract-plugin
export default {"wave":"Home_wave__24Bx4","shapefill":"Home_shapefill__LJMy3"};